import type { LotState } from '../hooks/useLotState';

type Props = {
  state: LotState;
  bidsCount: number;
  bidders: number;
  closedMinutesAgo?: number;
};

export function LiveStatusStrip({ state, bidsCount, bidders, closedMinutesAgo }: Props) {
  if (state === 'scheduled') {
    return (
      <div className="h-11 px-4 flex items-center border-y border-edge bg-bg-elev/40">
        <span className="font-mono text-[10px] tracking-[0.25em] text-warning flex items-center gap-2">
          <span className="w-1.5 h-1.5 rounded-full bg-warning anim-glow" />
          AUCTION OPENS SOON
        </span>
      </div>
    );
  }

  if (state === 'closed') {
    return (
      <div className="h-11 px-4 flex items-center justify-between border-y border-edge bg-bg-elev/40">
        <span className="font-mono text-[10px] tracking-[0.25em] text-fg-muted flex items-center gap-2">
          <span className="w-1.5 h-1.5 rounded-full bg-fg-dim" />
          CLOSED
          {typeof closedMinutesAgo === 'number' && (
            <span className="text-fg-dim normal-case tracking-normal">· {closedMinutesAgo} min ago</span>
          )}
        </span>
        <span className="font-mono text-[10px] tracking-wider text-fg-muted">
          {bidsCount} bids · {bidders} players
        </span>
      </div>
    );
  }

  return (
    <div className="h-11 px-4 flex items-center justify-between border-y border-edge bg-bg-elev/40">
      <span className="font-mono text-[10px] tracking-[0.25em] text-danger flex items-center gap-2">
        <span className="w-1.5 h-1.5 rounded-full bg-danger anim-blink" />
        LIVE
      </span>
      <span className="font-mono text-[10px] tracking-wider text-fg-muted">
        {bidsCount} bids · {bidders} players
      </span>
    </div>
  );
}
